import './styles.scss'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { I18n } from 'react-redux-i18n'

import poolLists from 'redux/poolLists/actions'
import { cleanExpandedUserTab, removeUserTabs, setActiveChannel, setExpandedUserTab } from 'redux/actions/tabs'
import { removeConversation } from 'redux/actions/conversations/conversations'
import { conversationAct } from 'redux_new/actions'
import { TextColorNotClient, UserAvatar, MenuDotsOptions } from 'components/common'
import { MnemonicsBadge } from 'components/mnemonics'
import { usersHelpers } from 'utils'
import { getStaticImage } from 'utils/statics'
import { getAssignToOthers, getChannelName } from 'utils/channelsUtils'
import { getDateTime, lang } from '../../utils/helpers'
import { apiConversation, deleteManagerAPI, exportManagerAPI } from 'api'
import { toast } from 'react-toastify'
import ListAssigned from './ListAssigned'

const getCompanyAndDelegation = (companyName, delegationName) => {
  let returnString = companyName || ''
  returnString += (companyName && delegationName) ? ' - ' : ''
  returnString += delegationName || ''

  return returnString
}

const getClassname = (user, activeUserId, openedUsersTabs) => {
  let className = ''

  const isActive = activeUserId === user?.id
  const isOpen = openedUsersTabs.includes(user?.id)
  const withDrafts = user.drafts

  if (isActive) className += ' user-card-new--is-active'
  if (isOpen && !isActive) className += ' user-card-new--is-open'
  if (withDrafts && !isActive && !isOpen) className += ' user-card-new--with-drafts'
  if (!user.isRead || user.pendingMsgCount > 0) className += ' user-card-new--unread'

  return className
}

const UserCard = (props) => {
  const {
    user,
    isActive,
    operatorCanAssignACardToItself,
    assignToMyself,
    unassignMe,
    isShowRemove,
    onClick,
    listId
  } = props

  const delegations = useSelector(state => state.delegations)
  const delegationName = (delegations[user.delegation] || {}).name
  const userCompanyInfo = getCompanyAndDelegation(user.companyName, delegationName)
  const channel = getChannelName(user.channels)
  const isRead = isActive ? true : user.isRead
  const dispatch = useDispatch()
  const history = useHistory()
  const currentUser = useSelector(state => state.user)
  const assignToOthers = getAssignToOthers(user, currentUser)
  const activeUser = useSelector(state => state.tabs?.activeUser)
  const openedUsersTabs = useSelector(state => state.tabs?.users).map(u => u.id)
  const expandedUserTab = useSelector(state => state.tabs?.expandedUserTab)

  const [isOpenConversationOptionsSelector, setIsOpenConversationOptionsSelector] = useState({})
  const [isOpenRemoveUserModal, setIsOpenRemoveUserModal] = useState(false)
  const [isOpenExportModal, setIsOpenExportModal] = useState(false)
  const [styleMenuDeleteExport, setStyleMenuDeleteExport] = useState('')

  const changeIsRead = async (value) => {
    await apiConversation.conversations.msgRead({
      ticketId: user._id,
      isRead: !value
    })

    if (user.isInList) {
      dispatch(poolLists.event({ onlyListIsAvailable: true }))
    }
    if (value) {
      dispatch(removeUserTabs(user.id))
      dispatch(conversationAct.removeOne(user.id))
      dispatch(removeConversation(user.id))
      history.push(`${history.location.pathname}`)
    }
  }

  const onClickCard = (e) => {
    if (e.target.id !== 'outboundIcon' && e.target.id !== 'messageIcon' && e.target.id !== 'removeIcon' && e.target.id !== 'assignToMeCardIcon'){
      dispatch(setActiveChannel(channel))
      onClick(user)
    }
  }

  const onRemoveFromList = () => {
    dispatch(poolLists.removeFromList({ action: 'remove', userId: user.id, listId: listId }))
  }

  const className = getClassname(user, activeUser, openedUsersTabs, expandedUserTab)

  const toggleConversationOptionsSelector = ({ id }) => {
    if (id) {
      setIsOpenConversationOptionsSelector(prevState => ({ ...prevState, [id]: !prevState[id] }))
    } else {
      setIsOpenConversationOptionsSelector({})
    }
  }

  const isOpenModalDeleteConversation = () => {
    setIsOpenRemoveUserModal(true)
    toggleConversationOptionsSelector({})
  }

  const isOpenModalExportConversation = () => {
    toggleConversationOptionsSelector({})
    setIsOpenExportModal(true)
  }

  const handleDeleteConversation = async () =>{
    try{
      const response = await deleteManagerAPI.deleteConversation({ userId: user.id })
      if(response.data?.success){
        dispatch(removeUserTabs(user.id))
        dispatch(conversationAct.removeOne(user.id))
        dispatch(removeConversation(user.id))
      }
    }catch(error){
      toast(lang('error_conversation_delete'), { position: 'top-right' })
    }
  }

  const handleExportConversation = async () =>{
    try{
      await exportManagerAPI.exportConversation({ userId: user.id })
      toast(lang('information_conversation_export'), { position: 'top-right' })
      setIsOpenExportModal(!isOpenExportModal)
    }catch(error){
      toast(lang('error_conversation_export'), { position: 'top-right' })
    }
  }

  const toggleDelete = () => setIsOpenRemoveUserModal(!isOpenRemoveUserModal)
  const toggleExport = () => setIsOpenExportModal(!isOpenExportModal)

  const toggleDotsOptions = (e) =>{
    if(e === undefined){
      setStyleMenuDeleteExport('')
      toggleConversationOptionsSelector({ })
    }
    else{
      e.stopPropagation()
      setStyleMenuDeleteExport('displayMenuDeleteExport')
      toggleConversationOptionsSelector({ id: user._id })
    }
  }

  return (
    <div
      className={`user-card-new fadeIn animated ${className}`}
      onClick={e => onClickCard(e)}
      onMouseEnter={() => {
        if (!openedUsersTabs.includes(user.id)) return
        dispatch(setExpandedUserTab(user.id))
      }}
      onMouseLeave={() => {
        if (expandedUserTab !== user.id) return
        dispatch(cleanExpandedUserTab(user.id))
      }}
    >
      <UserAvatar
        avatar={user.avatarUrl
          ? user.avatarUrl
          : ['instagram_post', 'facebook_post'].includes(channel)
            ? getStaticImage('/default-picture.png')
            : getStaticImage('/icons/orange-brand/icon-avatar.svg')
        }
        channel={channel}
        isSandbox={user.isSandbox}
        onErrorAvatar={event => {
          event.target.src = ['instagram_post', 'facebook_post'].includes(channel)
            ? getStaticImage('/default-picture.png')
            : getStaticImage('/icons/orange-brand/icon-avatar.svg')
          event.onerror = null
        }}
      />
      <div className='seccion-details'>
        <div className='user-name'>
          <TextColorNotClient
            name={['instagram_post', 'facebook_post'].includes(channel) ? user.description : usersHelpers.showName(user)}
            metadata={user.metadata}
          />
        </div>
        {['instagram_post', 'facebook_post'].includes(channel) && user.chatType !== 'mention' ? (
          <div className='post-card-comments'>
            <span className='text-ellipsis'>{user.commentsCount || 0} {user.commentsCount === 1 ? I18n.t('dashboard_comment') : I18n.t('dashboard_comments')}</span>
          </div>
        ) : userCompanyInfo && user.chatType !== 'mention' && (
          <div title={userCompanyInfo} className='user_company_info'>
            <span className='text-ellipsis'>{userCompanyInfo}</span>
          </div>
        )}
        {user?.aiGenerated?.topic ? (
          <div className='user_company_info--ai-topic' title={`${lang('dashboard_topic')}: ${user?.aiGenerated?.topic}`}>
            <figure>
              <img src={getStaticImage(`/icons/orange-brand/icon-topic-list.svg`)} alt={`icon-topic-list`} />
            </figure>
            <span className='text-ellipsis'>{user?.aiGenerated?.topic}</span>
          </div>
        ) : <div className='user_company_info--empty'>&nbsp;</div>}
        {user.chatType === 'mention' && (<div className='post-card-comments'><span className='text-ellipsis mention-name'>{user.nameMentions}</span></div>)}
        <span className='hour-time text-ellipsis'>{getDateTime(user.lastMessageSentAt || user.updatedAt, 'fullNotSeconds')}</span>
      </div>
      <div className='seccion-actions'>
        <div className='buttons-actions'>
          {user.outbound !== undefined && (
            <img
              id='outboundIcon'
              className='img-outbound'
              src={getStaticImage(`/icons/orange-brand/icon-outbound${user.outbound ? '' : '-disabled'}.svg`)}
              alt='outbound'
            />
          )}
          <img
            id='messageIcon'
            src={getStaticImage(`/icons/orange-brand/icon-${isRead ? 'read-primary' : 'unread-primary'}.svg`)}
            alt='unread'
            onClick={() => changeIsRead(user.isRead)}
          />
          {!currentUser.onlyAssignedConversations && (
            <ListAssigned
              assignToOthers={assignToOthers}
              user={user}
              operatorCanAssignACardToItself={operatorCanAssignACardToItself}
              assignToMyself={assignToMyself}
              unassignMe={unassignMe}
            />
          )}
          {isShowRemove && (
            <img
              id={'removeIcon'}
              className='img-remove'
              src={getStaticImage('/icons/orange-brand/icon-remove.svg')} alt={'remove'}
              onClick={onRemoveFromList}
              title={I18n.t('tooltip_remove_user_from_list')}
            />
          )}
        </div>
        {
          isActive
            ? null
            : (
              <MnemonicsBadge
                userId={user.id}
                isRead={isRead}
                location='userCard'
                value={user?.channelRemove ? user.pendingMsgCount : 0}
              />
            )
        }
        <div className='buttons-actions'>
          {user.chatType === 'mention' && <i className="fa fa-at mention" aria-hidden="true"/>}
          <MenuDotsOptions
            typeOptions={user.chatType === 'mention'? 'dotsOptionsVertical' : 'dotsOptions'}
            className={styleMenuDeleteExport}
            classNameDots={'newMenuHorizontalConversation'}
            isOpen={isOpenConversationOptionsSelector}
            id={user._id}
            toggleDotsOptions={toggleDotsOptions}
            toggle={toggleConversationOptionsSelector}
            setStyleMenu={setStyleMenuDeleteExport}
            options={[
              {
                id:'delete',
                name: I18n.t('dashboard_delete-conversation'),
                onClick:(e) => {
                  e.stopPropagation()
                  setStyleMenuDeleteExport('')
                  isOpenModalDeleteConversation()
                }
              },
              {
                id:'export',
                name: I18n.t('dashboard_export-conversation'),
                onClick: (e) =>{
                  e.stopPropagation()
                  setStyleMenuDeleteExport('')
                  isOpenModalExportConversation()
                }
              }
            ]}
            isOpenModalDelete={isOpenRemoveUserModal}
            isOpenModalExport={isOpenExportModal}
            toggleDelete={toggleDelete}
            toggleExport={toggleExport}
            type={'conversation'}
            eventDelete={() => {
              handleDeleteConversation()
              setIsOpenRemoveUserModal(!isOpenRemoveUserModal)
            }}
            eventExport={handleExportConversation}
          />
        </div>
      </div>
    </div>
  )
}

UserCard.propTypes = {
  user: PropTypes.any.isRequired,
  isActive: PropTypes.bool.isRequired,
  operatorCanAssignACardToItself: PropTypes.bool.isRequired,
  assignToMyself: PropTypes.any,
  unassignMe: PropTypes.any,
  isShowRemove: PropTypes.bool,
  onClick: PropTypes.any,
  listId: PropTypes.string,
}

export default UserCard
